<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentdata.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>

<div class="chip_cont" style="padding: 20px 0px">
    <mat-chip-listbox aria-label="Fish selection" class="mb-3" >
      <div *ngFor="let item of daysArray; let i = index" >
        <mat-chip
        [ngClass]="{'selected': item.is_selected == 1}"
         
          (click)="selectDay(i)"
          >{{ item.dayName }}
        </mat-chip>
      </div>
    </mat-chip-listbox>
  </div>
<div>
    <mat-form-field class="w-100" appearance="outline" (click)="pickerA.open()">
        <mat-label>From Time</mat-label>
        <input matInput
               name="selected_time_A"
               [ngxMatTimepicker]="pickerA"
               readonly
               [(ngModel)]="fromTime"/>
        <mat-icon matSuffix style="margin-right: 4px;">
          access_time
        </mat-icon>
    </mat-form-field>
    <ngx-mat-timepicker #pickerA ></ngx-mat-timepicker>
</div>
<div>
    <mat-form-field class="w-100" appearance="outline" (click)="pickerB.open()">
        <mat-label>To Time</mat-label>
        <input matInput
               name="selected_time_B"
               [ngxMatTimepicker]="pickerB"
               readonly
               [(ngModel)]="toTime"/>
        <mat-icon matSuffix style="margin-right: 4px;">
          access_time
        </mat-icon>
    </mat-form-field>
    <ngx-mat-timepicker #pickerB></ngx-mat-timepicker>
</div>
</mat-dialog-content>

  
<mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close
  
    >
      Cancel
    </button>
    <button
      
      mat-flat-button
      color="accent"
      (click)="onPost()"
      [disabled]="isNoDaySelected()"
    >
      Confirm
    </button>

  </mat-dialog-actions>